// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-about-tsx": function componentSrcPagesAboutTsx() {
    return import("./../../src/pages/about.tsx"
    /* webpackChunkName: "component---src-pages-about-tsx" */
    );
  },
  "component---src-pages-contact-tsx": function componentSrcPagesContactTsx() {
    return import("./../../src/pages/contact.tsx"
    /* webpackChunkName: "component---src-pages-contact-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-media-agencies-tsx": function componentSrcPagesMediaAgenciesTsx() {
    return import("./../../src/pages/media-agencies.tsx"
    /* webpackChunkName: "component---src-pages-media-agencies-tsx" */
    );
  },
  "component---src-pages-media-agency-tsx": function componentSrcPagesMediaAgencyTsx() {
    return import("./../../src/pages/media-agency.tsx"
    /* webpackChunkName: "component---src-pages-media-agency-tsx" */
    );
  },
  "component---src-pages-metodologia-tsx": function componentSrcPagesMetodologiaTsx() {
    return import("./../../src/pages/metodologia.tsx"
    /* webpackChunkName: "component---src-pages-metodologia-tsx" */
    );
  },
  "component---src-pages-privacy-tsx": function componentSrcPagesPrivacyTsx() {
    return import("./../../src/pages/privacy.tsx"
    /* webpackChunkName: "component---src-pages-privacy-tsx" */
    );
  },
  "component---src-pages-search-tsx": function componentSrcPagesSearchTsx() {
    return import("./../../src/pages/search.tsx"
    /* webpackChunkName: "component---src-pages-search-tsx" */
    );
  },
  "component---src-pages-tos-tsx": function componentSrcPagesTosTsx() {
    return import("./../../src/pages/tos.tsx"
    /* webpackChunkName: "component---src-pages-tos-tsx" */
    );
  }
};